"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
const WarningPeriscope = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _react.default.createElement("path", {
  d: "M15.9998 19.4583C15.3098 19.4583 14.7498 20.0183 14.7498 20.7083C14.7498 21.3983 15.3098 21.9583 15.9998 21.9583C16.6898 21.9583 17.2498 21.3983 17.2498 20.7083C17.2498 20.0183 16.6898 19.4583 15.9998 19.4583Z"
}), _react.default.createElement("path", {
  d: "M14.9998 10.7083V16.7083C14.9998 17.2603 15.4478 17.7083 15.9998 17.7083C16.5518 17.7083 16.9998 17.2603 16.9998 16.7083V10.7083C16.9998 10.1563 16.5518 9.70825 15.9998 9.70825C15.4478 9.70825 14.9998 10.1563 14.9998 10.7083Z"
}), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.8762 23.4765L16.8762 3.47949C16.5242 2.84049 15.4752 2.84049 15.1242 3.47949L4.12424 23.4765C3.95324 23.7865 3.95924 24.1635 4.13924 24.4675C4.31924 24.7715 4.64624 24.9585 5.00024 24.9585H27.0002C27.3532 24.9585 27.6802 24.7715 27.8602 24.4675C28.0402 24.1635 28.0462 23.7865 27.8762 23.4765ZM6.69124 22.9585L16.0002 6.03549L25.3082 22.9585H6.69124Z"
}));
const WarningMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("path", {
  fill: "currentColor",
  d: "M23.865 20.5l-11-19a1.04 1.04 0 00-1.73 0l-11 19A1 1 0 001 22h22a1 1 0 00.865-1.5zM13.206 8l-.473 6.6h-1.466L10.821 8zM12 19a1.467 1.467 0 111.467-1.467A1.467 1.467 0 0112 19z"
}));
const AbstractWarning = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(WarningMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(WarningPeriscope, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractWarning);